import validate from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import _404_45handler_45global from "/home/runner/work/pornplus/pornplus/frontend/middleware/404-handler.global.js";
import manifest_45route_45rule from "/home/runner/work/pornplus/pornplus/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _404_45handler_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/pornplus/pornplus/frontend/middleware/auth.ts"),
  "cache-control": () => import("/home/runner/work/pornplus/pornplus/frontend/middleware/cache-control.ts")
}